import React from 'react'
import { Column, WidgetCell, ComboBox, TextField, TextAreaField } from '@sencha/ext-modern'

import { genWidgetcellChangeHandler } from './utilities'

const render = ({ _text: text, dataIndex, edit, handleEdit, ...rest }) => {
	// console.log('render text:', text, dataIndex, edit, handleEdit, rest)
	return edit
		? <Column {...{ dataIndex, text, ...rest }} >
			<WidgetCell bodyStyle={{ padding: "0px 12px" }}>
				{edit.options || edit.bind.options
					? <ComboBox
						clearable={false}
						// forceSelection={true}
						editable={false}
						anyMatch={true}
						onChange={genWidgetcellChangeHandler(handleEdit, dataIndex, 'string')}
						{...edit} />
					// : edit.maxRows
					// 	? <TextAreaField
					// 		clearable={false}
					// 		onChange={genWidgetcellChangeHandler(handleEdit, dataIndex, 'string')}
					// 		{...edit}
					// 	/>
					: <TextField
						clearable={false}
						onChange={genWidgetcellChangeHandler(handleEdit, dataIndex, 'string')}
						{...edit}
					/>
				}
			</WidgetCell>
		</Column>
		: <Column {...{ dataIndex, text, ...rest }} />
}

export default render